export enum TablesFilterEnum {
    FAMILY = "FAMILY",
    ASSORTMENT = "ASSORTMENT",
    PRODUCT_DIVISION = "PRODUCT_DIVISION",
  }